import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '@/lib/utils';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

/*
 * Rendered without TooltipPrimitive.Portal: the scoped roi-shadcn.css theme
 * (--color-* vars, .dark) only cascades within .roi-page's subtree, and a
 * body-level portal would escape it and pick up no styling.
 */
function TooltipContent({
  className,
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Content
      sideOffset={sideOffset}
      className={cn(
        'z-50 max-w-[260px] rounded-md border border-border bg-card px-3 py-1.5 text-xs text-card-foreground shadow-md',
        className,
      )}
      {...props}
    />
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
